import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    showAccountServices: true,
    preferredAccountNumberFormat: 'SBBAN',
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
